<template>
  <div class="base-tabs-select">
    <button type="button" class="base-tabs-select__current" aria-haspopup="dialog" @click="open = true">
      <span class="base-tabs-select__label">{{ current ? current.label : '' }}</span>
      <BaseIcon name="chevron-down" class="base-tabs-select__chevron" aria-hidden="true" />
    </button>
    <BaseBottomSheet v-model="open" :title="title || $t('table.phone-list.show-title')">
      <ul class="base-bottom-sheet__menu" role="radiogroup">
        <li v-for="tab in tabs" :key="tab.key">
          <button
            type="button"
            role="radio"
            :aria-checked="String(tab.key === value)"
            :class="{ 'is-active': tab.key === value }"
            :disabled="tab.disabled"
            @click="choose(tab)"
          >
            {{ tab.label }}
            <BaseIcon v-if="tab.key === value" name="check" class="base-bottom-sheet__menu-check" />
          </button>
        </li>
      </ul>
    </BaseBottomSheet>
  </div>
</template>

<script>
import BaseBottomSheet from '@/components/base/BaseBottomSheet.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';

// On phones, a list's tabs that don't fit across the screen (docs/page-layout.md): the one shown,
// above the count line, and all of them in a sheet, as "Trier" offers its choices.
export default {
  name: 'BaseTabsSelect',
  components: { BaseBottomSheet, BaseIcon },
  props: {
    // The key of the tab shown.
    value: { type: [String, Number], required: true },
    // `{ key, label, disabled? }` each.
    tabs: { type: Array, required: true },
    // The sheet's title; "Afficher" by default.
    title: { type: String, default: '' },
  },
  data() {
    return { open: false };
  },
  computed: {
    current() {
      return this.tabs.find((tab) => tab.key === this.value);
    },
  },
  methods: {
    // A single choice closes the sheet (docs/page-layout.md).
    choose(tab) {
      this.open = false;
      if (tab.key !== this.value) this.$emit('input', tab.key);
    },
  },
};
</script>

<style lang="scss">
.base-tabs-select {
  &__current {
    display: flex;
    align-items: center;
    gap: $space-2;
    width: 100%;
    min-height: 44px;
    padding: 0 $space-3 0 $space-md;
    background: $color-white;
    border: 1px solid $color-border;
    border-radius: $radius-md;
    color: $color-text-title;
    font-weight: $font-weight-medium;
    text-align: left;
  }

  &__label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__chevron {
    flex: none;
    width: 20px;
    height: 20px;
    color: $color-text-muted;
  }
}
</style>
